// Category filter — client-side show/hide by data-category (no AJAX; the
// full set is server-rendered). Syncs ?category= for shareable deep links
// and supports browser back/forward.

export function initFilters() {
  document.querySelectorAll('[data-filter-bar]').forEach(setupBar);
}

function setupBar(bar) {
  const grid = document.querySelector(bar.dataset.filterTarget || '');
  if (!grid) return;

  const toggles = [...bar.querySelectorAll('.filter-bar__toggle')];
  const items = [...grid.querySelectorAll('[data-category]')];
  const empty = grid.querySelector('[data-filter-empty]') || grid.parentElement.querySelector('[data-filter-empty]');
  const hasAll = toggles.some((t) => t.dataset.category === 'all');

  const apply = (slug) => {
    toggles.forEach((t) => {
      const on = t.dataset.category === (slug || (hasAll ? 'all' : ''));
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-pressed', String(on));
    });

    let shown = 0;
    items.forEach((item) => {
      const cats = (item.dataset.category || '').split(/\s+/);
      const show = !slug || slug === 'all' || cats.includes(slug);
      item.hidden = !show;
      if (show) shown += 1;
    });
    if (empty) empty.hidden = shown > 0;
  };

  const current = () => {
    const slug = new URLSearchParams(location.search).get('category') || '';
    return toggles.some((t) => t.dataset.category === slug) ? slug : hasAll ? 'all' : '';
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      let slug = toggle.dataset.category;
      // Without an "All" pill, clicking the active droplet clears the filter.
      if (!hasAll && toggle.classList.contains('is-active')) slug = '';

      const url = new URL(location.href);
      if (slug && slug !== 'all') url.searchParams.set('category', slug);
      else url.searchParams.delete('category');
      history.pushState(null, '', url);

      apply(slug);
    });
  });

  window.addEventListener('popstate', () => apply(current()));
  apply(current());
}
